module.exports = __webpack_public_path__ + "media/images/dashboard/img_2-6896e35b601d5e4a3652ba6121fe74df.jpg";